import React, { Suspense } from 'react';
import CreateContainer from "./CreateContainer";

const CreateSegmentation = (props) => {
    return (
        <CreateContainer {...props} />
    );
};

export default CreateSegmentation;